import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Typography, Divider, Statistic, Row, Col } from 'antd';
import { CombinedStates } from '../../core/types';
import { BvmSurvey, BvmSurveyQuestion } from '../../core/bvm/types';

const { Title, Text } = Typography;

interface SchoolBvmSurveyStatisticsProps {
    schoolId: number;
}

const SchoolBvmSurveyStatistics: React.FC<SchoolBvmSurveyStatisticsProps> = () => {
    const { surveys } = useSelector((state: CombinedStates) => state.bvm);

    // Filter questions with non-null special values
    const getSpecialQuestions = (survey: BvmSurvey) => survey.questions.filter((question: BvmSurveyQuestion) => question.special !== null);

    // Calculate overall average for questions where special == 'balai' across all categories
    const calculateOverallBalaiAverage = () => {
        const allBalaiAnswers: number[] = [];
        surveys.forEach((survey: BvmSurvey) => {
            survey.questions.forEach((q: BvmSurveyQuestion) => {
                if (q.special === 'balai' && q.answer) {
                    const val = parseFloat(q.answer);
                    if (!Number.isNaN(val)) allBalaiAnswers.push(val);
                }
            });
        });
        if (allBalaiAnswers.length === 0) return null;
        const sum = allBalaiAnswers.reduce((a, b) => a + b, 0);
        return sum / allBalaiAnswers.length;
    };

    return (
        <div>
            {surveys.map((survey) => {
                const specialQuestions = getSpecialQuestions(survey);
                if (specialQuestions.length === 0) return null;

                return (
                    <Card key={survey.id} style={{ marginBottom: 16 }}>
                        <Title level={3}>{survey.title}</Title>
                        {survey.description && (
                            <Text type="secondary">{survey.description}</Text>
                        )}

                        <Divider />

                        {specialQuestions.map((question: BvmSurveyQuestion) => (
                            <div key={question.id} style={{ marginBottom: 16 }}>
                                <Text strong>{question.code} {question.title}</Text>
                                {question.description && (
                                    <div>
                                        <Text type="secondary">{question.description}</Text>
                                    </div>
                                )}
                                <div style={{ marginTop: 8 }}>
                                    {question.answer ? (
                                        <div>
                                            <Text>Atsakymas: {question.answer}</Text>
                                        </div>
                                    ) : (
                                        <div>
                                            <Text>Atsakymas nepateiktas</Text>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </Card>
                );
            })}
            {(() => {
                const overall = calculateOverallBalaiAverage();
                if (overall === null) return null;
                return (
                    <Card style={{ marginTop: 16 }}>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Statistic title="Visų kategorijų balų vidurkis" value={overall.toFixed(2)} precision={2} />
                            </Col>
                        </Row>
                    </Card>
                );
            })()}
        </div>
    );
};

export default SchoolBvmSurveyStatistics;
